import {useEffect, useState} from "react";
import "./singleTicketOpen.scss";
import {Link, useParams} from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import useFetch from "../../hooks/useFetch";
import {formatDate} from "../../helper/helper";
import CommentSection from "../../components/comentar/CommentSection";
const SingleOpenTicket = () => {
  const [ticketOpen, setTicketOpen] = useState([]);
  const { ticketId } = useParams();
  const  token = localStorage.getItem("token");
  const { data, loading, error } = useFetch(`/ticket/${ticketId}`);

  useEffect(() => {
    setTicketOpen(data);
  }, [data]);


  const dateTicket = () => {
    const dateCreated =  formatDate(ticketOpen.created_at);
    const dateUpdate = formatDate(ticketOpen.updated_at);


    const date = {
      create_at : dateCreated,
      updated_at: dateUpdate,
    }
    return date;
  }
const date = dateTicket()





  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <div className="top">
          {loading ? (
              "loading"
          ) : (
              <div className="left">
                <Link to={`/ticket/update/${ticketOpen.id}`} style={{textDecoration: "none"}}>
                  <div className="editButton">Edit</div>
                </Link>
                <div>
                  <Link to={`/solve/create/${ticketOpen.id}`} style={{textDecoration: "none"}}>
                    <div className="createButton">Create Ticket Solved</div>
                  </Link>
                </div>
                <h1 className="title">Information Ticket Open Detail</h1>
                <div className="item">
                  <img
                      src="https://images.pexels.com/photos/733872/pexels-photo-733872.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260"
                      alt=""
                      className="itemImg"
                  />
                  <div className="details">
                    <h1 className="itemTitle">Detail Ticket</h1>
                    <table className="detailsTable">
                      <tbody>
                      <tr>
                        <td className="itemKey">Ticket ID :</td>
                        <td className="itemValue">{ticketOpen.id}</td>
                      </tr>
                      <tr>
                        <td className="itemKey">Segment Customer:</td>
                        <td className="itemValue">{ticketOpen.segment_customer}</td>
                      </tr>
                      <tr>
                        <td className="itemKey">Region :</td>
                        <td className="itemValue">{ticketOpen.region_id}</td>
                      </tr>
                      <tr>
                        <td className="itemKey">Down Time :</td>
                        <td className="itemValue">{date.create_at}</td>
                      </tr>
                      <tr>
                        <td className="itemKey">Status ID :</td>
                        <td className="itemValue">{ticketOpen.status_id}</td>
                      </tr>
                      <tr>
                        <td className="itemKey">Category ID :</td>
                        <td className="itemValue">{ticketOpen.category_id}</td>
                      </tr>
                      <tr>
                        <td className="itemKey">Note :</td>
                        <td className="itemValue">{ticketOpen.note || "-"}</td>
                      </tr>
                      <tr>
                        <td className="itemKey">Created AT :</td>
                        <td className="itemValue">{date.create_at}</td>
                      </tr>
                      <tr>
                        <td className="itemKey">Last Updated AT :</td>
                        <td className="itemValue">{date.updated_at}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>)}
        </div>
        <div className="bottom">
          <CommentSection ticketId={ticketId}/>
          {/*  <h1 className="title">Last Open Ticket</h1>
          <DatatableForOpen columns={ticketOpenColumns}/>*/}
        </div>
      </div>
    </div>
  );
};

export default SingleOpenTicket;
